export const hasExtension = (file: any, extension: any)  => {
  return (new RegExp('(' + extension.join('|').replace(/\./g, '\\.') + ')$', 'i')).test(file.name);
}

export const getFileExtensionInFirebaseStorageUrl = (url: string): string | undefined => {
  return url.split(/[#?]/)[0].split('.').pop()?.trim();
}

export const isFileNamesSame = (fileName1: string, fileName2: string): boolean => {
  const [name1, extension1] = fileName1.split('.');
  const [name2, extension2] = fileName2.split('.');

  return name1.trim().toLowerCase() === name2.trim().toLowerCase() && extension1.trim().toLowerCase() === extension2.trim().toLowerCase();
}
